export default [
    'analytics',
    'products',
    'orders',
    'invoice',
    'notifications',
    'contact-us'
]
